import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: 'white',
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginTop: 30,
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 9,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: 'white',
    minHeight: 50,
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: '#f9f9f9',
    minHeight: 50,
  },
  typeColumn: {
    flex: 1.5,
    fontSize: 9,
  },
  methodColumn: {
    flex: 2,
    fontSize: 9,
    textAlign: 'center',
  },
  timeColumn: {
    flex: 2,
    fontSize: 9,
    textAlign: 'center',
  },
  statusColumn: {
    flex: 1,
    fontSize: 9,
    textAlign: 'center',
  },
  excludedText: {
    color: 'red',
  },
  includedText: {
    color: 'black',
  },
});

const ELDCamera = ({ operations }) => {
  const eldData = [
    {
      type: 'ELD',
      method:
        'Connect Current ELD device(s) to Cover Whale using the link emailed to you at binding',
      time: '10 Days from the bind date',
      status:
        operations?.dataSharingOption === 'eld_only'
          ? 'Included'
          : 'Excluded',
    },
    {
      type: 'DASH CAMERA',
      method:
        'Install and turn on the camera(s) that will be shipped to you post-binding',
      time: '10 Days from when the shipment is delivered to the insured',
      status:
        operations?.dataSharingOption === 'dash_cam_dual_ai_connected'
          ? 'Included'
          : 'Excluded',
    },
  ];

  return (
    <>
      <Text style={styles.title}>ELD/CAMERA</Text>

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.tableHeaderCell, styles.typeColumn]}>
            Telematics Type
          </Text>
          <Text style={[styles.tableHeaderCell, styles.methodColumn]}>
            Connection Method
          </Text>
          <Text style={[styles.tableHeaderCell, styles.timeColumn]}>
            Time Alotted to connect device(s)
          </Text>
          <Text style={[styles.tableHeaderCell, styles.statusColumn]}>
            Status
          </Text>
        </View>

        {eldData.map((item, index) => (
          <View
            key={item.type}
            style={
              index % 2 === 0 ? styles.tableRow : styles.tableRowAlt
            }
          >
            <Text style={styles.typeColumn}>{item.type}</Text>
            <Text style={styles.methodColumn}>{item.method}</Text>
            <Text style={styles.timeColumn}>{item.time}</Text>
            <Text
              style={[
                styles.statusColumn,
                item.status === 'Excluded'
                  ? styles.excludedText
                  : styles.includedText,
              ]}
            >
              {item.status}
            </Text>
          </View>
        ))}
      </View>
    </>
  );
};

export default ELDCamera;
